// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: none;
}

.dropdown-content {
  border-radius: 0.8rem;
  background: var(--text-link-color-white, #FFF);
  display: flex;
  flex-direction: column;
  box-shadow: 0px 16px 32px 0px rgba(97, 97, 97, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/shared/dropdown-menu/dropdown-menu.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,qBAAA;EACA,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,mDAAA;AACF","sourcesContent":[":host {\n  display: none;\n}\n\n.dropdown-content {\n  border-radius: 0.8rem;\n  background: var(--text-link-color-white, #FFF);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 16px 32px 0px rgba(97, 97, 97, 0.10);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
